import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { StadisticsService } from 'src/app/services/stadistics.service';
import { Singlecount } from 'src/app/models/stadistics/stadistics';
import { DashboardOption } from 'src/app/models/dashboard-option';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownComponent } from "../../shared/dropdown/dropdown.component";
import { FormsModule } from '@angular/forms';
import { DropdownService } from 'src/app/services/dropdown.service';
import { HorizontalDarChartComponent } from "../../shared/horizontal-dar-chart/horizontal-dar-chart.component";
import { PieChartComponent } from "../../shared/pie-chart/pie-chart.component";

@Component({
    selector: 'app-companies-statistics',
    templateUrl: './companies-statistics.component.html',
    styles: [],
    standalone: true,
 imports: [RouterLink, FormsModule, RouterLinkActive, CommonModule, DropdownComponent, HorizontalDarChartComponent, PieChartComponent]
})
export class CompaniesStatisticsComponent implements OnInit {
 private readonly stadisticsService = inject(StadisticsService);
  private readonly dropdownService = inject(DropdownService);
  showFilters: boolean = false;

  countries: DropdownOption[] = [];
  provinces: DropdownOption[] = [];
  municipalities: DropdownOption[] = [];
  typeContracts: DropdownOption[] = [];
  companies: DropdownOption[] = [];
  professionalProfiles: DropdownOption[] = [];

  filter: {
    countryId: number | null,
    provinceId: number | null,
    municipalitityId: number | null,
    typeContractId: number | null,
    companyId: number | null,
    professionalProfileId: number | null,
    ageRangeMin: number | null,
    ageRangeMax: number | null
  } = {
      countryId: null,
      provinceId: null,
      municipalitityId: null,
      typeContractId: null,
      companyId: null,
      professionalProfileId: null,
      ageRangeMin: null,
      ageRangeMax: null
    };

  indicators: {
    singlecount: Singlecount,
    jobofferpublised: {
      data: DashboardOption[],
      isNoData: boolean
    },
    topjobofferpublised: {
      data: DashboardOption[],
      isNoData: boolean
    },
    isLoading: boolean,
    hasError: boolean
  } = {
      jobofferpublised: {
        data: [],
        isNoData: false
      },
      topjobofferpublised: {
        data: [],
        isNoData: false
      },
      isLoading: false,
      hasError: false,
      singlecount: {
        users: 0,
        jobOffers: 0,
        candidates: 0
      }
    };

  constructor() { }

  ngOnInit(): void {
    this.getOptions();
  }

  ngAfterViewInit(): void {
    this.getMainStatistics();
  }


  getMainStatistics() {
    this.indicators.isLoading = true;
    this.stadisticsService.getMainStatistics(new Date().getFullYear()).subscribe({
      next: res => {
        this.indicators.singlecount = {
          users: res?.singlecount?.users ?? 0,
          jobOffers: res?.singlecount?.jobOffers ?? 0,
          candidates: res?.singlecount?.candidates ?? 0,
        }
        this.indicators.jobofferpublised.data = res?.jobofferpublised?.map((option, i) => ({
          id: i,
          labelId: i,
          labelName: option.description,
          countValue: option.quantity,
          serieName: option.description
        })) as DashboardOption[];
        this.indicators.jobofferpublised.isNoData = this.indicators?.jobofferpublised?.data?.length === 0;

        this.indicators.topjobofferpublised.data = res?.topjobofferpublised?.map((option, i) => ({
          id: i,
          labelId: i,
          labelName: option.description,
          countValue: option.quantity,
          serieName: 'Cantidad de ofertas publicadas'
        })) as DashboardOption[];
        this.indicators.topjobofferpublised.isNoData = this.indicators?.topjobofferpublised?.data?.length === 0;

        this.indicators.isLoading = false;
      }, error: res => {
        this.indicators.isLoading = false;
        this.indicators.hasError = true;
      }
    });
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.Countries).subscribe({
      next: res => {
        this.countries = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.ProfessionalProfiles).subscribe({
      next: res => {
        this.professionalProfiles = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.ContractTypes).subscribe({
      next: res => {
        this.typeContracts = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.UserCompanies).subscribe({
      next: res => {
        this.companies = res;
      }
    });
  }

  changeCountry() {
    const countryId = this.filter?.countryId?.toString();
    if (!countryId) {
      this.provinces = [];
      this.municipalities = [];
      this.filter.provinceId = null;
      this.filter.municipalitityId = null;
      return;
    }
    this.dropdownService.GetOptions(DropDownKeywords.Provinces, 1, countryId).subscribe({
      next: res => {
        this.provinces = res;
      }
    });
  }

  changeProvince() {
    const provinceId = this.filter?.provinceId?.toString();
    if (!provinceId) {
      this.municipalities = [];
      this.filter.municipalitityId = null;
      return;
    }
    this.dropdownService.GetOptions(DropDownKeywords.Cities, 1, provinceId).subscribe({
      next: res => {
        this.municipalities = res;
      }
    });
  }

  showFilter(): void {
    this.showFilters = !this.showFilters;
  }
}
